import React, { useEffect, useState } from 'react';
import DefaultSEO from '../components/DefaultSEO';
import { contactService } from '../services/contactService';

const ContactPage = () => {
  const [contactInfo, setContactInfo] = useState({
    email: 'contact@zoyotrip.com',
    phone: '',
    address: '67 C21 Res-Com Mall Nanakheda Ujjain Madhya Pradesh, India',
    facebook: '',
    instagram: '',
    twitter: '',
    linkedin: '',
    youtube: ''
  });

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    number: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  useEffect(() => {
    fetchContact();
  }, []);

  const fetchContact = async () => {
    try {
      const response = await contactService.getContactDetails();
      if (response.status && response.data) {
        setContactInfo(response.data);
      }
    } catch (error) {
      console.error("Error fetching contact details:", error);
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await contactService.sendContactMessage(formData);
      if (response.success) {
        setStatus({ type: 'success', message: 'Message sent successfully!' });
        setFormData({ name: '', email: '', number: '', message: '' });
      } else {
        setStatus({ type: 'danger', message: response.message || 'Failed to send message.' });
      }
    } catch (error) {
      console.error("Error sending message:", error);
      const errorMsg = error.response?.data?.message || 'Something went wrong. Please try again later.';
      setStatus({ type: 'danger', message: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DefaultSEO 
        title="Contact Us | ZoyoTrip" 
        description="Get in touch with ZoyoTrip for support, booking inquiries, and partnerships."
      />
      <div className="container py-5">
        <h1 className="fw-bolder display-5 mb-5 text-center text-primary" style={{ fontSize: '3rem' }}>Get in Touch</h1>

        <div className="row align-items-stretch overflow-hidden" style={{ background: "#f9f9f9" }}>
          {/* Left: Contact Info */}
          <div className="col-lg-6 p-5 d-flex flex-column justify-content-center" style={{ backgroundColor: "#fff" }}>
            <h3 className="fw-bold mb-3 text-dark">Reach Out to ZoyoTrip</h3>
            <p className="text-muted mb-4">Have questions about bookings, support, or partnerships? We're here to help!</p>

            <div className="mb-3">
              <i className="bi bi-geo-alt-fill me-2 text-primary"></i>
              <span className="text-muted">{contactInfo.address}</span>
            </div>
            <div className="mb-3">
              <i className="bi bi-envelope-fill me-2 text-primary"></i>
              <a href={`mailto:${contactInfo.email}`} className="text-decoration-none text-muted">
                {contactInfo.email}
              </a>
            </div>
            {contactInfo.phone && (
              <div className="mb-3">
                <i className="bi bi-telephone-fill me-2 text-primary"></i>
                <span className="text-muted">{contactInfo.phone}</span>
              </div>
            )}

            <div className="mt-4">
              <span className="text-muted">Follow us:</span>
              <div className="d-flex gap-3 mt-2 align-items-center">
                {contactInfo.facebook && (
                  <a href={contactInfo.facebook} target="_blank" rel="noopener noreferrer" className="text-muted fs-5">
                    <i className="bi bi-facebook text-primary"></i>
                  </a>
                )}
                {contactInfo.instagram && (
                  <a href={contactInfo.instagram} target="_blank" rel="noopener noreferrer" className="text-muted fs-5">
                    <i className="bi bi-instagram text-danger"></i>
                  </a>
                )}
                {contactInfo.linkedin && (
                  <a href={contactInfo.linkedin} target="_blank" rel="noopener noreferrer" className="text-muted fs-5">
                    <i className="bi bi-linkedin text-primary"></i>
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* Right: Contact Form */}
          <div className="col-lg-6 bg-light p-5">
            <h4 className="fw-semibold mb-4">Send Us a Message</h4>
            {status.message && (
              <div className={`alert alert-${status.type} rounded-pill px-4 mb-4`} role="alert">
                {status.message}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Full Name</label>
                <input
                  type="text"
                  id="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="form-control rounded-pill px-4 py-2"
                  placeholder="Your name"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email Address</label>
                <input
                  type="email"
                  id="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="form-control rounded-pill px-4 py-2"
                  placeholder="your@email.com"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Phone Number</label>
                <input
                  type="text"
                  id="number"
                  value={formData.number}
                  onChange={handleInputChange}
                  className="form-control rounded-pill px-4 py-2"
                  placeholder="Your phone number"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Message</label>
                <textarea
                  id="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className="form-control rounded-4 px-4 py-3"
                  rows="4"
                  placeholder="Write your message here..."
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                disabled={loading}
                className="btn btn-primary px-4 py-2 rounded-pill fw-semibold"
              >
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
